import { jsx, Fragment } from 'preact/jsx-runtime';
import { useState, useEffect } from 'preact/hooks';
import { signal } from '@preact/signals';

var PluginName;
(function (PluginName) {
    PluginName["DragAndDrop"] = "dragAndDrop";
    PluginName["EventModal"] = "eventModal";
    PluginName["ScrollController"] = "scrollController";
    PluginName["EventRecurrence"] = "eventRecurrence";
    PluginName["Resize"] = "resize";
    PluginName["CalendarControls"] = "calendarControls";
    PluginName["Sidebar"] = "sidebar";
    PluginName["Header"] = "header";
})(PluginName || (PluginName = {}));

/**
 * Can be used for generating a random id for an entity
 * Should, however, never be used in potentially resource intense loops,
 * since the performance cost of this compared to new Date().getTime() is ca x4 in v8
 * */
const randomStringId = () => 's' + Math.random().toString(36).substring(2, 11);

function Sidebar({ $app }) {
    const [sidebarId] = useState(randomStringId());
    const customComponent = $app.config._customComponentFns.sidebar;
    useEffect(() => {
        var _a;
        if (customComponent) {
            // const setIsOpen = (value: boolean) => {
            //   if ($app.config.plugins.sidebar) {
            //     $app.config.plugins.sidebar.isOpen.value = value
            //   }
            // }
            customComponent(document.querySelector(`[data-ccid=${sidebarId}]`), {
                isOpen: (_a = $app.config.plugins.sidebar) === null || _a === void 0 ? void 0 : _a.isOpen,
            });
        }
    }, []);
    return (jsx("div", { id: sidebarId, "data-ccid": sidebarId, className: "sx__calendar-sidebar", children: !customComponent && (jsx(Fragment, { children: "custom sidebar in the sidebar.tsx" })) }));
}

const createSidebarPlugin = () => {
    // const timeRange = signal<[Date, Date] | null>(null)
    // const profiles = signal<string[] | null>(null)
    // const sidebarAddresses = signal<string[] | null>(null)
    // const motives = signal<string[] | null>(null)
    return {
        name: PluginName.Sidebar,
        isOpen: signal(true),
        // setIsOpen,/
        // timeRange,
        // profiles,
        // motives,
        // sidebarAddresses,
        // setAddresses: (
        //   addresses: string[],
        // ) => {
        //   sidebarAddresses.value = addresses
        // },
        ComponentFn: Sidebar,
    };
};

export { createSidebarPlugin };
